import * as React from 'react';
import StickyNode from 'react-stickynode';

const Sticky = ({ children , top , bottomBoundary , enabled  })=>/*#__PURE__*/ React.createElement(StickyNode, {
        top: top,
        bottomBoundary: bottomBoundary,
        enabled: enabled
    }, children)
;

export { Sticky as default };
//# sourceMappingURL=Sticky.js.map
